const { default: axiosIns } = require('@/libs/axios')

const CampaignsService = {
  // GET - CampaignApiController
  async get(id, accountId) {
    return axiosIns.get(`/campaigns/${id}?accountId=${accountId}`).then(response => response.data)
  },
  async getCampaigns(adId, accountId) {
    return axiosIns.get(`/campaigns?accountId=${accountId}&adId=${adId}`).then(response => response.data)
  },
  // POST - CampaignApiController
  async createCampaign(model, accountId) {
    return axiosIns.post(`/campaigns?accountId=${accountId}`, model).then(response => response.data)
  },
  async duplicateCampaign(campaign, accountId) {
    return axiosIns.post(`/campaigns/${campaign.campaignId}?accountId=${accountId}`, campaign).then(response => response.data)
  },
}

export default CampaignsService
